/*
  ============================================================
  carrinho.js — carrinho sem recarregar a pagina
  ============================================================

  O QUE FAZ:
  Intercepta o "adicionar ao carrinho" e o "remover linha", fala
  com a Cart AJAX API da Shopify e volta a desenhar a gaveta com o
  HTML que a propria Shopify devolve.

  A DECISAO CENTRAL — QUEM CALCULA OS PRECOS:
  Depois de cada alteracao, este ficheiro pede
  /cart?sections=carrinho-gaveta e substitui a gaveta inteira pelo
  HTML recebido. Nao soma precos, nao aplica descontos, nao calcula
  IVA. Tudo isso e feito pela Shopify e chega ja escrito.

  Porque isto importa nesta loja: ha descontos por quantidade,
  IVA a 23% e um limiar de portes gratis. Se o total fosse somado
  em JavaScript, mais cedo ou mais tarde divergia do total real e a
  pessoa so descobria no checkout — que e o pior sitio possivel
  para uma surpresa no preco.

  SEM JAVASCRIPT A LOJA CONTINUA A FUNCIONAR:
  O formulario de produto e um <form> normal para /cart/add e o
  botao de remover e um <a> para /cart/change. Se este ficheiro
  falhar a carregar, ou se um pedido rebentar, a accao segue pelo
  caminho tradicional com recarregamento de pagina. Nunca fica um
  botao que nao faz nada.
*/
(function () {
  'use strict';

  var rotas = (window.bcs && window.bcs.rotas) || {
    carrinho: '/cart',
    adicionar: '/cart/add',
    alterar: '/cart/change'
  };
  var textos = (window.bcs && window.bcs.textos) || {};

  /* ----------------------------------------------------------
     Redesenhar a gaveta com HTML vindo da Shopify
     ---------------------------------------------------------- */

  function atualizarGaveta() {
    return fetch(rotas.carrinho + '?sections=carrinho-gaveta', {
      headers: { Accept: 'application/json' }
    })
      .then(function (resposta) {
        if (!resposta.ok) throw new Error('sections falhou');
        return resposta.json();
      })
      .then(function (dados) {
        var html = dados['carrinho-gaveta'];
        if (!html) return;

        var novo = new DOMParser().parseFromString(html, 'text/html');

        // A gaveta e o veu sao irmaos: trocam-se um a um, para nao
        // destruir o veu que esta a meio da transicao de opacidade.
        var gavetaNova = novo.querySelector('[data-gaveta-carrinho]');
        var gavetaAtual = document.querySelector('[data-gaveta-carrinho]');

        if (gavetaNova && gavetaAtual) {
          var estavaAberta = gavetaAtual.classList.contains('esta-aberto');
          gavetaAtual.innerHTML = gavetaNova.innerHTML;
          if (estavaAberta) gavetaAtual.classList.add('esta-aberto');
        }

        atualizarContador(novo);
      })
      .catch(function () {
        // Se o redesenho falhar, pelo menos o contador fica certo
        return atualizarContadorPorJson();
      });
  }

  function atualizarContador(documentoNovo) {
    var origem = documentoNovo && documentoNovo.querySelector('[data-contador-carrinho]');
    if (!origem) return atualizarContadorPorJson();
    escreverContador(origem.textContent.trim());
  }

  function atualizarContadorPorJson() {
    return fetch(rotas.carrinho + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (carrinho) { escreverContador(carrinho.item_count); })
      .catch(function () {});
  }

  function escreverContador(valor) {
    document.querySelectorAll('[data-contador-carrinho]').forEach(function (elemento) {
      elemento.textContent = valor;
    });
  }

  function piscarBotaoCarrinho() {
    var botao = document.querySelector('[data-abrir-carrinho]');
    if (!botao) return;
    botao.classList.add('esta-a-piscar');
    setTimeout(function () { botao.classList.remove('esta-a-piscar'); }, 600);
  }

  function avisar(mensagem, tipo) {
    if (typeof window.mostrarAlerta === 'function') {
      window.mostrarAlerta(mensagem, tipo || 'positivo');
    }
  }

  /* ----------------------------------------------------------
     Adicionar ao carrinho
     ---------------------------------------------------------- */

  document.addEventListener('submit', function (evento) {
    var formulario = evento.target;
    if (!formulario.matches('form[action*="/cart/add"], form[data-type="add-to-cart-form"]')) return;

    evento.preventDefault();

    var botao = formulario.querySelector('[type="submit"], [name="add"]');
    if (botao) botao.setAttribute('aria-busy', 'true');

    fetch(rotas.adicionar + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(formulario)
    })
      .then(function (resposta) {
        return resposta.json().then(function (dados) {
          if (!resposta.ok) throw dados;
          return dados;
        });
      })
      .then(function () {
        return atualizarGaveta();
      })
      .then(function () {
        piscarBotaoCarrinho();
        /* A gaveta abre sozinha: confirma o que aconteceu mostrando
           o carrinho real, em vez de pedir um acto de fe a um aviso
           que desaparece em quatro segundos. */
        if (typeof window.bcsAbrirCarrinho === 'function') {
          window.bcsAbrirCarrinho();
        } else {
          avisar(textos.adicionado || 'Adicionado ao carrinho');
        }
      })
      .catch(function (erro) {
        /* Erro devolvido pela Shopify (por exemplo, stock insuficiente):
           tem uma mensagem util e nao vale a pena recarregar a pagina. */
        if (erro && erro.description) {
          avisar(erro.description, 'negativo');
        } else {
          formulario.submit();
        }
      })
      .finally(function () {
        if (botao) botao.removeAttribute('aria-busy');
      });
  });

  /* ----------------------------------------------------------
     Remover linha do carrinho
     ---------------------------------------------------------- */

  document.addEventListener('click', function (evento) {
    var remover = evento.target.closest('[data-remover-linha]');
    if (!remover) return;

    evento.preventDefault();

    var linha = remover.closest('[data-linha-carrinho]');
    if (linha) linha.style.opacity = '0.4';

    fetch(rotas.alterar + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: remover.dataset.chave, quantity: 0 })
    })
      .then(function (resposta) {
        if (!resposta.ok) throw new Error('change falhou');

        /* Na propria pagina do carrinho nao chega actualizar a
           gaveta: o que a pessoa esta a ver e a tabela, e essa
           continuaria a mostrar a linha removida. Recarregar traz
           a tabela e os totais certos, calculados pela Shopify. */
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
          return;
        }

        return atualizarGaveta();
      })
      .catch(function () {
        // Deixa o link seguir o seu caminho normal
        window.location.href = remover.getAttribute('href');
      });
  });

  /* ----------------------------------------------------------
     Arranque
     ---------------------------------------------------------- */

  /* O contador vem escrito no HTML pelo servidor, mas o Shopify
     serve paginas em cache: alguem que volte atras no browser pode
     apanhar um numero antigo. Uma leitura no arranque resolve. */
  document.addEventListener('DOMContentLoaded', atualizarContadorPorJson);
})();
